import {useEffect} from "react";
import {route} from "ziggy-js";
import {
    getPriceFromProductData,
    hasStock,
    isAvailable,
    isNotAvailable,
    ProductAvailability,
    ProductMarkers,
    ProductOtherModels,
    ProductSizes
} from "@/entities/product";
import {AddToWaitListButton} from "@/features/add-to-waitList";
import {BasketActionButton} from "@/features/basket-actions";
import {BuyOneClickButton} from "@/features/buyOneClick";
import {ProductDelivery} from "@/features/product-delivery";
import {ShareButton} from "@/features/share-article";
import {FavoriteButton} from "@/features/toggle-favorite";
import {declOfNum} from "@/shared/lib/number/declOfNum";
import {formatPrice} from "@/shared/lib/format/formatPrice";
import {pageEvents} from "@/shared/lib/events";
import {Svg} from "@/shared/ui/Svg";
import {ProductPurchaseBar} from "@/widgets/product-purchase-bar";
import {ProductRelated} from "@/widgets/product-related";
import {ProductRecommend} from "@/widgets/product-recommend";
import {ProductViewed} from "@/widgets/product-viewed";
import {ProductGarnitur} from "@/widgets/product-garnitur";
import {ProductInformation} from "@/widgets/product-information";
import {ProductReviews} from "@/widgets/product-reviews";
import {ProductMainCarousel} from "@/widgets/product-main-carousel";
import styles from "./ui/Index.module.scss";
import {useFindOutYourSizeStore, useProductStore} from "@/Stores/Site/Product"; // Legacy
import {useModalStore} from "@/Stores/Site/ModalStore"; // Legacy
import BaseLayout from "@/Layouts/BaseLayout"; // Legacy
import WhySuchPriceModal from "@/Components/Modal/WhySuchPriceModal"; // Legacy
import {dataLayerPush, updateUrlParam} from "@/Helpers/Function"; // Legacy
import reachGoalVkAds from "@/Helpers/ReachGoalVkAds"; // Legacy
import BreadcrumbsComponent from "@/Legacy/pages/product/BreadcrumbsComponent"; // Legacy

const Index = (props) => {
    const {
        product,
        product_data_current = null,
        recommendedProducts,
        viewedProducts,
        isMobile,
        isDesktop,
        authCheck
    } = props;
    const {id = null, article, h1, product_data, productsRelated, productsGarnitur} = product;

    const initProduct = useProductStore(state => state.initProduct);
    const changeProduct = useProductStore(state => state.changeProduct);
    const deleteProduct = useProductStore(state => state.deleteProduct);
    const openModalFindOutYourSize = useFindOutYourSizeStore(state => state.openModalFindOutYourSize);

    const productDetailSwitchSize = useProductStore(state => state.switchSize);
    const openWhySuchPriceModal = useModalStore(state => state.openWhySuchPriceModal);

    initProduct(product, product_data_current);
    const productDataCurrent = useProductStore(state => state.productDataCurrent) ?? product_data_current;

    useEffect(() => {
        changeProduct(product_data_current);

        return () => deleteProduct();
    }, [product]);

    useEffect(() => {
        if (!productDataCurrent) return;

        let price = productDataCurrent.price_minimum !== 0 ? productDataCurrent.price_minimum : productDataCurrent.card_price;
        dataLayerPush('view_item', 'detail', 'viewItem', 'product', '',
            [{
                ...product,
                'product_id': product.id,
                'count': 1,
                'price': price,
            }]
        );
        // Отправка цели VK
        reachGoalVkAds('viewProduct', price, product.id);
    }, [product]);

    /**
     * Временное решение, принудительно поднять вверх
     */
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 700) // дать странице время дорисоваться
        return () => clearTimeout(timeout);
    }, []);

    /**
     * Добавляем в просмотренные
     */
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (id) {
                axios.post(route('viewed.add'), {product_id: id});
            }
        }, 150);
        return () => clearTimeout(timeout);
    }, [id]);

    const scrollToReviews = () => {
        pageEvents.scrollToReviews.emit();
    }

    const {
        current,
        original,
        hasDiscount,
        discount,
    } = getPriceFromProductData(productDataCurrent);

    const onSwitchSize = (el) => {
        productDetailSwitchSize(el);
        updateUrlParam('size', el.razmer, false);
    }

    const availableSizes = product_data.filter((item) => item.razmer);

    return (
        <BaseLayout {...props}>
            <div className={styles.breadcrumbs}>
                <div className={`globalContainer`}>
                    <BreadcrumbsComponent {...props} />
                </div>
            </div>
            <div className={styles.section}>
                <div className={`globalContainer`}>
                    <div className={styles.mainContainer}>
                        <div className={styles.carouselContainer}>
                            <ProductMainCarousel product={product} />
                        </div>
                        <div className={styles.infoContainer}>
                            {/*<ProductMarkers sticker={product.sticker} className={styles.markerT} />*/}
                            <div className={styles.headerContainer}>
                                <div className={styles.trash}>
                                    <div className={styles.trashLeft}>
                                        <p className={styles.article}>Артикул: {article}</p>
                                        <div className={styles.reviews} onClick={scrollToReviews}>
                                            {product.review.length > 0 ? (
                                                <>
                                                    <div className={styles.ratingContainer}>
                                                        <Svg id={`star`} className={styles.starIcon} />
                                                        <p className={styles.ratingAVG}>{product.ratingAVG}</p>
                                                    </div>
                                                    <p className={styles.countReviewsContainer}>
                                                        <span>{product.review.length} </span>
                                                        {declOfNum(product.review.length, ['отзыв', 'отзыва', 'отзывов'])}
                                                    </p>
                                                </>
                                            ) : (
                                                <>
                                                    <Svg id={`star`} className={styles.starIcon} />
                                                    <p className={styles.notRatingText}>Нет оценок</p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.headerButtons}>
                                        <div className={styles.shareContainer}>
                                            <ShareButton text={h1} isMobile={isMobile} />
                                        </div>
                                        <FavoriteButton
                                            product={product}
                                            className={styles.favoritesIconContainer}
                                        />
                                    </div>
                                </div>
                                <h1 className={styles.h1}>{h1}</h1>
                            </div>
                            {isNotAvailable(product) && (
                                <p className={styles.notAvailable}>Временно недоступно для заказа!</p>
                            )}
                            {isAvailable(product) && (
                                <>
                                    <div className={styles.priceContainer}>
                                        {hasStock(productDataCurrent.kol) ?
                                            <>
                                                <div className={styles.price}>
                                                    <p className={styles.current}>{formatPrice(current)}</p>
                                                    {hasDiscount && (
                                                        <>
                                                            <p className={styles.original}>{formatPrice(original)}</p>
                                                            <p className={styles.discount}>-{discount}%</p>
                                                        </>
                                                    )}
                                                </div>
                                                {hasDiscount && (
                                                    <>
                                                        <p
                                                            className={styles.whySuchPriceText}
                                                            onClick={openWhySuchPriceModal}
                                                        >
                                                            Почему такая цена?
                                                        </p>
                                                        <WhySuchPriceModal
                                                            productDataCurrent={productDataCurrent}
                                                            {...props}
                                                        />
                                                    </>
                                                )}
                                            </>
                                            :
                                            <p className={styles.outOfStockText}>Товар закончился</p>
                                        }
                                    </div>
                                    <div className={styles.sizeContainer}>
                                        <div className={styles.sizes}>
                                            {availableSizes.length > 0 && (
                                                <>
                                                    <div className={styles.sizeHeader}>
                                                        <p className={styles.sizeTitle}>Размер</p>
                                                        {(product.category === 'Кольца') && (
                                                            <p
                                                                className={styles.findYourSize}
                                                                onClick={openModalFindOutYourSize}
                                                            >
                                                                Как узнать свой размер?
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div className={styles.sizeBody}>
                                                        <ProductSizes
                                                            sizes={availableSizes}
                                                            selectedSize={productDataCurrent.razmer}
                                                            onSwitchSize={onSwitchSize}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className={styles.sizeFooter}>
                                                <ProductAvailability count={productDataCurrent.kol} />
                                            </div>
                                        </div>
                                        <div className={styles.buttons}>
                                            {hasStock(productDataCurrent.kol) ?
                                                <>
                                                    <BasketActionButton
                                                        product={product}
                                                        productDataId={productDataCurrent.id}
                                                        addText={`Добавить в корзину`}
                                                        inBasketText={`Перейти в корзину`}
                                                        fullWidth
                                                    />
                                                    <BuyOneClickButton
                                                        productId={id}
                                                        selectedSize={productDataCurrent.razmer}
                                                        fullWidth
                                                    />
                                                </>
                                                :
                                                <AddToWaitListButton
                                                    productId={product.id}
                                                    selectedSize={productDataCurrent.razmer}
                                                    fullWidth
                                                >
                                                    Уведомить о поступлении
                                                </AddToWaitListButton>
                                            }
                                        </div>
                                    </div>
                                    <ProductOtherModels products={product.productsModel} />
                                    <ProductDelivery productDataCurrent={productDataCurrent} />
                                    <ProductInformation
                                        product={product}
                                        productDataCurrent={productDataCurrent}
                                        aboutDecorationData={product.aboutDecorationData}
                                        previewLength={isMobile ? 25 : 45}
                                    />
                                    <ProductGarnitur
                                        products={productsGarnitur}
                                        collection={product.collection}
                                        collectionAlias={product.collectionAlias}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className={`globalContainer`}>
                    <ProductReviews
                        reviews={product.review}
                        ratingAVG={product.ratingAVG}
                        reviewAdd={product.reviewAdd}
                        authCheck={authCheck}
                        productId={product.id}
                        numberOfCharacters={isDesktop ? 100 : 40}
                    />
                </div>
                <ProductRelated products={productsRelated} />
                <ProductRecommend products={recommendedProducts} />
                <ProductViewed products={viewedProducts} />
            </div>
            <ProductPurchaseBar
                product={product}
                productDataCurrent={productDataCurrent}
            />
        </BaseLayout>
    );
}

export default Index;
